export default __webpack_public_path__ + "static/embrlabs-c89ee64a23fd8508710d58b8977185d5.png";